<script>
    import FileUpload from "../../../../components/FileUpload";
    export default {
        name: "RepairerFileUpload",
        extends: FileUpload
    }
</script>